"use client"

import { useTranslations } from "next-intl"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import type { UserPreferredLanguage } from "@/lib/zenstack/models"

export function LocalLangSwitch({
  value,
  onChange,
  isFrError,
  isEnError,
}: {
  value: UserPreferredLanguage
  onChange: (value: UserPreferredLanguage) => void
  isFrError: boolean
  isEnError: boolean
}) {
  const t = useTranslations("common.lang")
  return (
    <div className="flex gap-2">
      <Button
        type="button"
        variant={value === "en" ? "default" : "outline"}
        className={cn({ "bg-destructive text-white": isEnError })}
        onClick={() => onChange("en")}
      >
        {t("en")}
      </Button>
      <Button
        type="button"
        variant={value === "fr" ? "default" : "outline"}
        className={cn({ "bg-destructive text-white": isFrError })}
        onClick={() => onChange("fr")}
      >
        {t("fr")}
      </Button>
    </div>
  )
}
